/** Default service radius (km) when listing publicData.location.radius is unset */
export const DEFAULT_LISTING_SERVICE_RADIUS_KM = 20;

const EARTH_RADIUS_KM = 6371;

const toRad = degrees => (degrees * Math.PI) / 180;

/**
 * Haversine distance in km between two lat/lng points.
 * @param {{ lat: number, lng: number }} a
 * @param {{ lat: number, lng: number }} b
 */
export const distanceInKm = (a, b) => {
  if (!a || !b || a.lat == null || a.lng == null || b.lat == null || b.lng == null) {
    return null;
  }
  const dLat = toRad(b.lat - a.lat);
  const dLng = toRad(b.lng - a.lng);
  const lat1 = toRad(a.lat);
  const lat2 = toRad(b.lat);
  const h =
    Math.sin(dLat / 2) ** 2 + Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) ** 2;
  return EARTH_RADIUS_KM * 2 * Math.atan2(Math.sqrt(h), Math.sqrt(1 - h));
};

export const getListingServiceRadiusKm = listing => {
  const radius = listing?.attributes?.publicData?.location?.radius;
  return typeof radius === 'number' && radius > 0 ? radius : DEFAULT_LISTING_SERVICE_RADIUS_KM;
};

/**
 * True when search origin lies within the listing provider's service radius.
 */
export const listingServesSearchOrigin = (listing, searchOrigin) => {
  const geolocation = listing?.attributes?.geolocation;
  if (!searchOrigin || !geolocation) {
    return false;
  }
  const distanceKm = distanceInKm(searchOrigin, geolocation);
  if (distanceKm == null) {
    return false;
  }
  return distanceKm <= getListingServiceRadiusKm(listing);
};

export const filterListingsByServiceRadius = (listings, searchOrigin) => {
  if (!searchOrigin || !Array.isArray(listings)) {
    return listings;
  }
  return listings.filter(listing => listingServesSearchOrigin(listing, searchOrigin));
};
